export default "__VITE_ASSET__CM6D$5hQ__"